import React from 'react'
import { Form } from 'react-bootstrap'

const TokenDisplay = ({ selectedToken, actionText }) => {
  return (
    <Form.Group className="mb-3">
      <Form.Label>Token to {actionText}</Form.Label>
      <div className="card">
        <div className='card-body p-2'>
          {selectedToken ? (
            <div className="d-flex align-items-center gap-3">
              <img
                src={selectedToken.image}
                alt={selectedToken.name}
                width="32"
                height="32"
                className="rounded-circle"
              />
              <span>
                {selectedToken.name} ({selectedToken.balance} {selectedToken.symbol})
              </span>
            </div>
          ) : (
            <span className="text-muted">No token selected</span>
          )}
        </div>
      </div>
    </Form.Group>
  )
}

export default TokenDisplay
